import { ServiceDetails } from './models/entities';

const ServiceRoleMap: { [key: string]: ServiceDetails } = {
    "role": {
        "serviceId": 'role',
        "roles": {
            'ADMIN': {
                "name": 'ADMIN',
                "defaultTTL": 300,
                "description": "Grants full CRUD access to roles"
            }
        }
    },
    "auth": {
        "serviceId": 'auth',
        "roles": {
            'ADMIN_FULLACCESS': {
                "name": 'ADMIN_FULLACCESS',
                "defaultTTL": 300,
                "description": "GetPublicKey, Login, ChangePassowrd, GetUser, UpdateUser, DeleteUser"
            },
            'ADMIN_READONLY': {
                "name": 'ADMIN_READONLY',
                "defaultTTL": 300,
                "description": "GetPublicKey, Login, ChangePassowrd, GetUser"
            },
            'ADMIN_READUPDATE': {
                "name": 'ADMIN_READUPDATE',
                "defaultTTL": 300,
                "description": "GetPublicKey, Login, ChangePassowrd, GetUser, UpdateUser"
            },
            'NORMAL': {
                "name": 'NORMAL',
                "defaultTTL": 1800,
                "description": "GetPublicKey, Login, ChangePassowrd"
            },
        }
    },
    "account": {
        "serviceId": 'account',
        "roles": {
            'ADMIN': {
                "name": 'ADMIN',
                "defaultTTL": 300,
                "description": "full access"
            },
            'NORMAL': {
                "name": 'NORMAL',
                "defaultTTL": 3000,
                "description": "basic access"
            }
        }
    },
    "ebm": {
        "serviceId": "ebm",
        "roles": {
            "APPLICANT": {
                "name": "APPLICANT",
                "defaultTTL": 300,
                "description": "APPLICANT role grants permission to validate and upload a file with adding metadata. Also an user with this role can read the settings of EBM."
            },
            "APPROVER": {
                "name": "APPROVER",
                "defaultTTL": 300,
                "description": "APPROVER role grants permission to add a timestamp explicitly. Also an user with this role can read the settings of EBM."
            },
            "ADMIN": {
                "name": "ADMIN",
                "defaultTTL": 300,
                "description": "This role is responsible for managing various settings of EBM."
            },
            "RECEIPT_AUDITOR": {
                "name": "RECEIPT_AUDITOR",
                "defaultTTL": 300,
                "description": "All receipt search related operations are accessible with this role."
            },
            "INVOICE_AUDITOR": {
                "name": "INVOICE_AUDITOR",
                "defaultTTL": 300,
                "description": "All invoice search related operations are accessible with this role."
            },
            "JOURNAL_AUDITOR": {
                "name": "JOURNAL_AUDITOR",
                "defaultTTL": 300,
                "description": "All journal evidence search related operations are accessible with this role."
            },
            "RECEIPT_TIMESTAMPER": {
                "name": "RECEIPT_TIMESTAMPER",
                "defaultTTL": 300,
                "description": "Let user manually add timestamp to untimestamped submitted receipt documents"
            },
            "JOURNAL_TIMESTAMPER": {
                "name": "JOURNAL_TIMESTAMPER",
                "defaultTTL": 300,
                "description": "Let user manually add timestamp to untimestamped submitted journal documents"
            },
            "INVOICE_TIMESTAMPER": {
                "name": "INVOICE_TIMESTAMPER",
                "defaultTTL": 300,
                "description": "Let user manually add timestamp to untimestamped submitted invoice documents"
            },
        }
    },
    "journal": {
        "serviceId": "journal",
        "roles": {
            "APPLICANT": {
                "name": "APPLICANT",
                "defaultTTL": 300,
                "description": "APPLICANT role grants permission to apply a journal."
            },
            "APPROVER": {
                "name": "APPROVER",
                "defaultTTL": 300,
                "description": "APPROVER role grants permission to approve a journal."
            },
            "ADMIN": {
                "name": "ADMIN",
                "defaultTTL": 300,
                "description": "ADMIN role grants full permission to journal application"
            },
            "APPLICANT_READONLY": {
                "name": "APPLICANT_READONLY",
                "defaultTTL": 300,
                "description": "APPLICANT_READONLY role grants permission to read a journal."
            }
        }
    },
    "scheduler": {
        "serviceId": "scheduler",
        "roles": {
            "DEFAULT": {
                "name": "DEFAULT",
                "defaultTTL": 300,
                "description": "The default role for Scheduler. A user with ADMIN role can change the permissions of the role."
            },
            "ADMIN": {
                "name": "ADMIN",
                "defaultTTL": 60,
                "description": "ADMIN role grants permissions for accessing admin pages"
            }
        }
    },
    "acmaster": {
        "serviceId": "acmaster",
        "roles": {
            "ACMASTER_READONLY": {
                "name": "ACMASTER_READONLY",
                "defaultTTL": 300,
                "description": "ACMASTER_READONLY role grants permission to read, search master data from acmaster cloud service."
            },
            "ACMASTER_ADMIN": {
                "name": "ACMASTER_ADMIN",
                "defaultTTL": 300,
                "description": "ACMASTER_ADMIN role grants permission to edit, read, search master data from acmaster cloud service."
            }
        }
    },
    "service": {
        "serviceId": "service",
        "roles": {
            "ADMIN": {
                "name": "ADMIN",
                "defaultTTL": 300,
                "description": "ADMIN can do crud operatons on services and their roles"
            },
            "DEVELOPER": {
                "name": "ADMIN",
                "defaultTTL": 300,
                "description": "DEVELOPER can do crud operatons on services and their roles"
            },
            "USER": {
                "name": "USER",
                "defaultTTL": 1800,
                "description": "USER can get list of services and their default roles"
            }
        }
    },
    "ess": {
        "serviceId": "ess",
        "roles": {
            "ESS_ADMIN": {
                "name": "ESS_ADMIN",
                "defaultTTL": 300,
                "description": "ess admin"
            },
            "ESS_APPLICANT": {
                "name": "ESS_APPLICANT",
                "defaultTTL": 300,
                "description": "ess applicant"
            }
        }
    }
}

function getServiceDefaultRoles() {
    return ServiceRoleMap;
}

export { getServiceDefaultRoles }


// WEBPACK FOOTER //
// ./src/ServiceRoles.tsx